<app-multi-select-dropdown
    [context]="context"
    dropdownLabel="Rule"
    [options]="rules$ | async"
    [isMultiSelect]="isMultiSelect"
    (submitDropdownMultiSelect)="submitDropdownMultiSelect($event)"
    (submitDropdownSingleSelect)="submitDropdownSingleSelect($event)"
>
</app-multi-select-dropdown>
